const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export default CHANGE_LANGUAGE;
